module.exports = __webpack_public_path__ + "static/media/footer-img.7dde6bd0.png";